
export const state = {
    user: null,
    modules: [],
    questions: [],
    choices: [],
    questionnaire: [],
    aboutUs: [],
    slogans: [],
    awards: [],
    privacyPolicy: [],
};